import React, {useState} from "react";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import {Button, Flex, Form, Input, message} from "antd";
import {getUserInfo} from "../../../GlobalServices";
import {setHaslo} from "../Services";

const Ustawienia = () => {
    const [zmiana, setZmiana] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const onClickZmien = (form: any) => {
        setZmiana(true);
        let dane = {
            login: getUserInfo()?.uzytkownik?.username,
            pass: form.pass
        }

        console.log(dane);

        setHaslo(dane).then((response) => {
            let user = getUserInfo();

            localStorage.setItem('sygnalistaTopUser', JSON.stringify({
                uzytkownik: user.uzytkownik,
                credentials: "Basic " + btoa(dane.login + ":" + dane.pass)
            }))

            messageApi.open({
                type: 'success',
                content: `Hasło zostało zmienione`,
                duration: 5,
            });
            setZmiana(false);
        }).catch((error) => {
            console.log('error');
            messageApi.open({
                type: 'error',
                content: `Wystąpił błąd podczas próby zmiany hasła`,
                duration: 5,
            });
            setZmiana(false);
        })
    }

    return (
        <AdminPanelLayaut label={'Ustawienia'}>

            <h6>Zmień hasło</h6>
            <Form
                name="basic"
                // labelCol={{ span: 8 }}
                wrapperCol={{ span: 4 }}
                style={{ paddingTop: '15px' }}
                initialValues={{ remember: true }}
                onFinish={onClickZmien}
                onFinishFailed={() => console.log('error')}
                autoComplete="off"
                layout={'vertical'}
            >
                <Form.Item
                    label="Hasło"
                    name="pass"
                    rules={[{ required: true, message: 'Pole wymagane' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Flex justify={'space-between'}>
                        <Button type="primary" htmlType="submit" loading={zmiana}>
                            Zmień
                        </Button>
                    </Flex>
                </Form.Item>
            </Form>
            {contextHolder}
        </AdminPanelLayaut>
    )
}

export default Ustawienia;
